
import { Router } from '@angular/router';
import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';

import {HomeService} from './home.service';
import {setting} from '../../../setting';
import { CarouselBreakpoint } from '../shared/utils/infinite-carousel';
import CssFilterConverter from 'css-filter-converter';
import { SignupComponent } from './signup/signup.component';
import { ClientService } from '../services/client.service';
import { ColorToFilterResult } from 'css-filter-converter/lib/shared/types/result';
import { Notification, NotificationService } from '../shared/notifications/notification.service';
import { ClientSetting, SectionAboutUs } from '../interfaces/clientSetting.interface';


@Component({
	selector: 'usb-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	providers: [HomeService]
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChildren('icon', { read: ElementRef }) icons!: QueryList<ElementRef>;
  @ViewChildren('iconLearning', { read: ElementRef }) iconLearning!: QueryList<ElementRef>;
  @ViewChild(SignupComponent) SignupComponent!: SignupComponent;
  @ViewChild('modalJoinus') modalJoinus!: ElementRef;
  @ViewChild('closeButton') closeButton!: ElementRef;
  @ViewChild('openModalSuccessJoinUs') openModalSuccessJoinUs!: ElementRef;
  @ViewChild('closeButtonModalSuccessSignUp') closeButtonModalSuccessSignUp!: ElementRef;

  // Mismos tramos que el "responsive" de owl que reemplaza (0→1, 400→2, 740→3, 940→4, 1140→6),
  // para conservar la misma cantidad de logos visibles por ancho de pantalla. La mecánica del
  // carrusel (autoplay, flechas, breakpoints) ahora vive en <usb-carousel> (ver template).
  brandsCarouselBreakpoints: CarouselBreakpoint[] = [
    { minWidth: 0, items: 1 },
    { minWidth: 400, items: 2 },
    { minWidth: 740, items: 3 },
    { minWidth: 940, items: 4 },
    { minWidth: 1140, items: 6 }
  ];

  modalOpen: boolean = false;

	public baseUrl: string = '';
	public apiBookingUrl: string = '';
	public domain: string;
	public getClientsSettingAppAuth: ClientSetting | null = null;
	public sectionAboutUs: SectionAboutUs | null = null;
  public sectionBrands: any;
	public sectionLogin: any;
	public sectionTraining: any;
	public sectionDestinity: any;
	public sectionRegister: any;
	public loadSetting : boolean;
	public routeUploadFile:any;
  public images:any = [];
  public imagesAboutUs: any = [];
  public filter?: any;
  public textLearning: any;
  public titleContext: any;
  public buttonSuccess: boolean = false;
  public imageUrl: string = '';
  public showSplashScreen: boolean = false;
  public isModalOpen: boolean | null = null;
  public heroVariant = setting.heroVariant;

	constructor(
    private router: Router,
    private clientService: ClientService,
    public notificationService: NotificationService
	){
		this.domain = setting.c_domain;
		this.loadSetting = false;
	}
  ngOnDestroy(): void {
    // this.getClientsSettingAppAuthSubscription.unsubscribe();


  }

    ngOnInit() {
      // CARGA CONFIGURACION DEL CLIENTE
      this.loadSetting = true;
      this.showSplashScreen = true;
      this.routeUploadFile =  setting.routeUploadFile;
      // this.consultClient = this.clientStorage();

      // Suscribirse a los datos del cliente
        this.clientService.clientData$.subscribe((clientData) => {
            if (clientData) {

                this.loadClientData(clientData);
            }
        });

        // Suscribirse al estado de carga
        this.clientService.isLoading().subscribe((loading) => {
            // ✅ Cuando loading es false, significa que ya cargó
            if (!loading) {
                this.loadSetting = true;
            }
        });
    }

        private loadClientData(clientData: ClientSetting): void {
        if (!clientData?.clients_setting_app_auth) return;

        this.getClientsSettingAppAuth = clientData;

        this.sectionAboutUs = JSON.parse(clientData.clients_setting_app_auth.section_about_us) as SectionAboutUs;
        this.sectionBrands = JSON.parse(clientData.clients_setting_app_auth.section_brands);
        this.sectionLogin = JSON.parse(clientData.clients_setting_app_auth.section_login);
        this.sectionDestinity = JSON.parse(clientData.clients_setting_app_auth.section_destinity);
        this.sectionTraining = JSON.parse(clientData.clients_setting_app_auth.section_training);
        this.sectionRegister = JSON.parse(clientData.clients_setting_app_auth.section_register);

        this.loadBrandsCarousel();
        this.loadImagesAboutUs();
        this.applyImageFilter();
        this.applyFilterLearning();
        this.textLearning = this.sectionTraining?.learning?.text;
        this.titleContext = this.sectionAboutUs?.fairs?.title_context;
        this.imageUrl = this.getBackgroundImageUrl();
        this.loadSetting = true;
        this.showSplashScreen = false;

    }

  private getBackgroundImageUrl(): string {
    return `url("${this.routeUploadFile}${this.sectionLogin?.background_image}")`;
  }

  loadBrandsCarousel(){
    for (let index = 0; index < this.sectionBrands?.brands_carousel.length; index++) {
      this.images[index] = this.routeUploadFile + this.sectionBrands?.brands_carousel[index];
    }
  }

  loadImagesAboutUs() {
    this.imagesAboutUs = [];
    const fairsBackgroundImages = this.sectionAboutUs?.fairs?.background_image;
    if (Array.isArray(fairsBackgroundImages)) {
      this.imagesAboutUs = fairsBackgroundImages.map(image => this.routeUploadFile + image);
    }
  }

  // Aplica un filtro de css al elemento de imagen utilizando el color seteado por cliente.
  applyImageFilter() {
    const color: string = this.getClientsSettingAppAuth?.clients_setting_global?.color_main_3 ?? '';
        const tempFilterObj: ColorToFilterResult<string | null> = CssFilterConverter.hexToFilter(color, { sheen: false });

    //Extraemos el literal en String de la conversión
    const tempFilterStr: string = Object.entries(tempFilterObj)
          .filter(([_, value]) => value !== null) // Filtrar valores null
          .map(([key, value]) => `${key}(${value})`)
          .join(" ");

    // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
    const colorRegex: RegExp = /color\((.*)\)/;
    const colorMatch: RegExpMatchArray | null = tempFilterStr.match(colorRegex);
    const colorFilter = colorMatch ? colorMatch[1] : "";

    this.filter = colorFilter;

    // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
    setTimeout(() => {
      this.icons.forEach(icon => {
        icon.nativeElement.setAttribute('style', `filter: ${this.filter}`);
      });
    }, 100);
  }

  applyFilterLearning(): void {
    const color: string = this.sectionTraining.learning?.color;
    const tempFilterObj: ColorToFilterResult<string | null> = CssFilterConverter.hexToFilter(color, { sheen: false });

    //Extraemos el literal en String de la conversión
    const tempFilterStr: string = Object.entries(tempFilterObj)
          .filter(([_, value]) => value !== null) // Filtrar valores null
          .map(([key, value]) => `${key}(${value})`)
          .join(" ");

    // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
    const colorRegex: RegExp = /color\((.*)\)/;
    const colorMatch: RegExpMatchArray | null = tempFilterStr.match(colorRegex);
    const colorFilter: string = colorMatch ? colorMatch[1] : "";

    this.filter = colorFilter;

    // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
    setTimeout(() => {
      this.iconLearning.forEach(icon => {
        icon.nativeElement.setAttribute('style', `filter: ${this.filter}`);
      });
    }, 100);

  }

  onLinkClick() {
    this.router.navigate(['/articles']).then(() => {
      window.scrollTo(0, 0);
    });
  }

  successEvent() {
    this.closeButton.nativeElement.click();

    if(!this.buttonSuccess) {
      this.buttonSuccess = true;
      this.openModalSuccessJoinUs.nativeElement.click();

      setTimeout(() => {
        this.isModalOpen = null;
        this.closeButtonModalSuccessSignUp.nativeElement.click();
      }, 3000);
    }
    this.buttonSuccess = false;

  }

  errorEvent() {
    setTimeout(() => {
      this.modalJoinus.nativeElement.click();
    }, 500);

  }

  changeOpenModal(): void {
    this.isModalOpen = true;
  }

  closeModalRegister(): void {
    this.isModalOpen = null;
  }

  getBackgroundLearning(): string {
    if(setting.name === 'Usblick') {
      return '#f0ebed';
    }


      return 'transparent';
  }

  getPaddingBottomLearning(): string {
      if(setting.name === 'Usblick') {
      return '35px';
    }


      return '0';
  }

}


